import ApiService from '@/data/services/ApiService'
import { AxiosResponse } from 'axios'
import { IServiceResponse } from '@/data/models/ServiceResponse'

export class ExternalEventApiService extends ApiService {
  /**
   * Fetches external events based on provided parameters
   *
   * @param data
   */
  static async getEvents(data: object): Promise<IServiceResponse<object>> {
    return this.axios.get('external-events', {
      params: data
    }).then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  static async getCatapultActivities(data: object): Promise<IServiceResponse<object>> {
    return this.axios.get('external-events/catapult-activities', {
      params: data
    }).then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  static async getGpexeActivities(data: object): Promise<IServiceResponse<object>> {
    return this.axios.get('external-events/gpexe-activities', {
      params: data
    }).then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  static async getPolarTeamActivities(data: object): Promise<IServiceResponse<object>> {
    return this.axios.get('external-events/polar-team-activities', {
      params: data
    }).then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }
}
